import i18n from '@/i18n'

export default [
    {
        value: '1',
        label: i18n.t('triggerGoal.itsATriggerGoal'),
        isDefault: false,
    },
    {
        value: '0',
        label: i18n.t('triggerGoal.isntATriggerGoal'),
        isDefault: true,
    },
]
